<template>
  <!-- 赠送金 -->
  <div id="coupon">
    <el-card shadow="never">
      <el-tabs v-model="activeName" @tab-click="handleClick" id="resetTabs">
        <el-tab-pane v-for="i in tabsList" :key="i.type" :label="i.name" :name="i.type.toString()">
          <el-alert title="赠送金只能在订单支付和补差时使用，不能在还款时使用"  show-icon type="warning"  :closable="false"></el-alert>
          <div class="voucher_top"><img src="../../assets/img/djq.png"/>
          <span v-if="activeName == 1">个人赠送金余额：<span class="redColor">¥{{userInfo.cashCouponBalance ? userInfo.cashCouponBalance.toFixed(2) : '0.00'}}</span></span>
            <span v-if="activeName == 2">团队赠送金余额：<span class="redColor">¥{{userInfo.cashTeamCouponBalance ? userInfo.cashTeamCouponBalance.toFixed(2) : '0.00'}}</span></span>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-card style="margin: 30px 0" shadow="never">
      <div slot="header">
        <div class="desciconLarge"></div>
        <span class="font18">赠送金记录</span>
      </div>
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{background:'#F5F5F5'}" >
        <el-table-column prop="type"  label="操作" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1">入账</span>
            <span v-if="scope.row.type == 2">使用</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderCode"  label="订单编号" align="center"></el-table-column>
        <el-table-column prop="userName" v-if="activeName == 2" label="使用人" align="center">
          <template slot-scope="scope">
             <span v-if="scope.row.type == 2">{{scope.row.userName}}</span>
            <span v-if="scope.row.type == 1">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="money"  label="操作金额" align="center">
          <template slot-scope="scope">
            ¥{{scope.row.money || '0.00'}}
          </template>
        </el-table-column>
        <el-table-column prop="addDate" width="200" label="操作时间" align="center"></el-table-column>
      </el-table>
      <el-pagination
        background
        v-if="total > 0"
        style="text-align: right;margin-top: 10px"
        layout="total,prev, pager, next"
        :current-page="pageNum"
        :page-size="pageSize"
        :total="total"
        @current-change="selPageChange"
      ></el-pagination>
    </el-card>
  </div>
</template>
<script>
import { getClient } from "@/plugins/auth";
import { couponRecordList } from "@/api/request";
export default {
  data() {
    return {
      activeName: "1",
      activeIndex: 1,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      userInfo: JSON.parse(getClient()),
      tabsList: [
        { name: "个人赠送金", type: 1 },
        { name: "团队赠送金", type: 2 }
      ],
      tableData: []
    };
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      couponRecordList({linkId: this.userInfo.clientId,linkType: this.activeName}).then(res=> {
        this.tableData = res.rows
      })
    },
    selPageChange(page) {
      this.pageNum = page;
      this.getList();
    },
    handleClick(tab, event) {
      this.getList()
    }
  }
};
</script>
<style scoped lang="scss">
.voucher_top {
    padding: 10px;
    display: flex;
    align-items: center;
    img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
    }
}
</style>
